import vars from '@/assets/styles/vars'

export default function Picture({ desktop, tablet, mobile, alt = '', isLazy = false }) {
  const desktopImages = desktop || {}
  const {
    x1: desktop_x1,
    x2: desktop_x2,
    webp_x1: desktop_webp_x1,
    webp_x2: desktop_webp_x2,
  } = desktopImages

  const tabletImages = tablet || {}
  const {
    x1: tablet_x1,
    x2: tablet_x2,
    webp_x1: tablet_webp_x1,
    webp_x2: tablet_webp_x2,
  } = tabletImages

  const mobileImages = mobile || {}
  const {
    x1: mobile_x1,
    x2: mobile_x2,
    webp_x1: mobile_webp_x1,
    webp_x2: mobile_webp_x2,
  } = mobileImages

  if (!desktop_x1) {
    return (
      <img src="data:image/svg+xml,%3Csvg id='noimage_product.svg' xmlns='http://www.w3.org/2000/svg' width='450' height='450' viewBox='0 0 450 450'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23000; fill-opacity: 0.05; %7D .cls-2 %7B fill: %232b303e; fill-rule: evenodd; opacity: 0.07; %7D %3C/style%3E%3C/defs%3E%3Crect id='Rectangle_658_copy_20' data-name='Rectangle 658 copy 20' class='cls-1' width='450' height='450'/%3E%3Cpath id='Rounded_Rectangle_942_copy_2' data-name='Rounded Rectangle 942 copy 2' class='cls-2' d='M503,712H261c-9.941,0-16-6.059-16-16V454c0-9.941,6.059-16,16-16H503c9.941,0,16,6.059,16,16V696C519,705.941,512.941,712,503,712Zm-4-20V612.947l-55.016-54.886-44.9,44.791L488.446,692H499Zm-38.849,0-97.167-96.939L265.817,692H460.151ZM265,458V664.587l90.911-90.7a10.019,10.019,0,0,1,14.147,0l14.883,14.848,51.97-51.848a10.019,10.019,0,0,1,14.147,0L499,584.719V458H265Zm58,95a37,37,0,1,1,37-37A37,37,0,0,1,323,553Zm0-54a17,17,0,1,0,17,17A17,17,0,0,0,323,499Z' transform='translate(-157 -350)'/%3E%3C/svg%3E%0A" alt="Placeholder"/>
    )
  }

  return desktop_x1.endsWith('.svg') ? (
    <img src={desktop_x1} alt={alt} />
  ) : (
    <picture>
      <source
        type="image/webp"
        media={`(min-width: ${vars.breakpoints.tablet + 1}px)`}
        srcSet={`${desktop_webp_x1}, ${desktop_webp_x2} 2x`}
      />
      <source
        media={`(min-width: ${vars.breakpoints.tablet + 1}px)`}
        srcSet={`${desktop_x1}, ${desktop_x2} 2x`}
      />

      <source
        type="image/webp"
        media={`(min-width: ${vars.breakpoints.mobile + 1}px)`}
        srcSet={`${tablet_webp_x1}, ${tablet_webp_x2} 2x`}
      />
      <source
        media={`(min-width: ${vars.breakpoints.mobile + 1}px)`}
        srcSet={`${tablet_x1}, ${tablet_x2} 2x`}
      />

      <source
        type="image/webp"
        media={`(max-width: ${vars.breakpoints.mobile}px)`}
        srcSet={`${mobile_webp_x1}, ${mobile_webp_x2} 2x`}
      />
      <source
        type="image/png"
        media={`(max-width: ${vars.breakpoints.mobile}px)`}
        srcSet={`${mobile_x1}, ${mobile_x2} 2x`}
      />

      <img src={desktop_x1} srcSet={`${desktop_x2} 2x`} alt={alt} loading={isLazy?"lazy":"eager"} decoding={isLazy?"async":"auto"}/>
    </picture>
  )
}
